import { IS_EA } from '@ben/shared/constants';
import { useQueryEmployerMe } from '../queries/use-query-employer-me';
import { useQueryMe } from '../queries/use-query-me';

export const useMeShared = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { data: eaData } = useQueryMe({ enabled: IS_EA && enabled });
  const { data: eccData } = useQueryEmployerMe({ enabled: !IS_EA && enabled });

  return IS_EA ? eaData : eccData;
};

export default useMeShared;
